import React, { useEffect, useRef, useState } from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { NavLink } from 'react-router-dom';
import Aos from 'aos';
import ScrollToTopButton from './ScrollToTopButton';

const useCounter = (end, duration = 2000) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        let start = 0;
        const increment = end / (duration / 50); // 50ms interval
        const interval = setInterval(() => {
            start += increment;
            if (start >= end) {
                clearInterval(interval);
                setCount(end);
            } else {
                setCount(Math.ceil(start));
            }
        }, 50);

        return () => clearInterval(interval);
    }, [end, duration]);

    return count;
};

const Home = () => {
    const [transform, setTransform] = useState({ rotateX: 0, rotateY: 0 });
    const handleMouseMove = (e) => {
        const { width, height, left, top } = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - left;
        const y = e.clientY - top;

        const rotateX = ((y / height) - 0.5) * -20; // Negative for natural tilt
        const rotateY = ((x / width) - 0.5) * 20;

        setTransform({ rotateX, rotateY });
    };

    const resetTransform = () => {
        setTransform({ rotateX: 0, rotateY: 0 });
    };

    const count1 = useCounter(20);
    const count2 = useCounter(35);
    const count3 = useCounter(26);
    const count4 = useCounter(100);


    // slider2
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    useEffect(() => {
        Aos.init({
            duration: 1000, // animation duration in ms
            once: false,
            mirror: true,
        });
    }, []);

    const handleSlideChange = () => {
        setTimeout(() => {
            Aos.refresh(); // refresh AOS after slide change
        }, 100);
    };

    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div className='header-mainsection'>
                <ScrollToTopButton />
                <Swiper
                    spaceBetween={30}
                    centeredSlides={true}
                    autoplay={{
                        delay: 4500,
                        disableOnInteraction: false,
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    navigation={true}
                    loop={true}
                    modules={[Autoplay, Pagination, Navigation]}
                    className="mySwiper custom-swiper"
                    onSlideChange={handleSlideChange}
                >
                    <SwiperSlide>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='homemain-leftsection'>
                                        <p className='leftsection-subtext'
                                            data-aos="fade-right"
                                            data-aos-offset="200"
                                            data-aos-easing="ease-in-sine"
                                        >
                                            4Sight Tech INFORMATION TECHNOLOGY
                                        </p>
                                        <h1 className='leftsection-head' data-aos="fade-right"
                                            data-aos-offset="300"
                                            data-aos-easing="ease-in-sine"
                                        >
                                            Cloud
                                        </h1>
                                        <h1 className='leftsection-head leftsection-head2' data-aos="fade-right"
                                            data-aos-offset="300"
                                            data-aos-easing="ease-in-sine">
                                            Services
                                        </h1>
                                        <p className='leftsection-txt'>
                                            We offer cloud services to optimize infrastructure, enhance scalability, and drive digital transformation. 🚀
                                        </p>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div
                                        className='homemain-rightsection'
                                        onMouseMove={handleMouseMove}
                                        onMouseLeave={resetTransform}
                                        style={{
                                            transform: `perspective(1000px) rotateX(${transform.rotateX}deg) rotateY(${transform.rotateY}deg)`,
                                            transition: 'transform 0.1s ease',
                                            transformStyle: 'preserve-3d'
                                        }}
                                    >
                                        <img className='home-rightsecim' src='../assets/images/slide/cloud.webp' alt='slider-image' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='homemain-leftsection'>
                                        <p className='leftsection-subtext' data-aos="fade-right"
                                            data-aos-offset="200"
                                            data-aos-easing="ease-in-sine">4Sight Tech INFORMATION TECHNOLOGY</p>
                                        <h1 className='leftsection-head' data-aos="fade-right"
                                            data-aos-offset="200"
                                            data-aos-easing="ease-in-sine">Software</h1>
                                        <h1 className='leftsection-head leftsection-head2' data-aos="fade-right"
                                            data-aos-offset="200"
                                            data-aos-easing="ease-in-sine">Development</h1>
                                        <p className='leftsection-txt'>We offer software development services to build scalable, high-performance, and innovative solutions tailored to business needs. 🚀</p>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div
                                        className='homemain-rightsection'
                                        onMouseMove={handleMouseMove}
                                        onMouseLeave={resetTransform}
                                        style={{
                                            transform: `perspective(1000px) rotateX(${transform.rotateX}deg) rotateY(${transform.rotateY}deg)`,
                                            transition: 'transform 0.1s ease',
                                            transformStyle: 'preserve-3d'
                                        }}
                                    >
                                        <img className='home-rightsecim' src='../assets/images/slide/softwareTemplete.webp' alt='slider-image' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='homemain-leftsection'>
                                        <p className='leftsection-subtext' data-aos="fade-right"
                                            data-aos-offset="200"
                                            data-aos-easing="ease-in-sine">4Sight Tech INFORMATION TECHNOLOGY</p>
                                        <h1 className='leftsection-head' data-aos="fade-right"
                                            data-aos-offset="200"
                                            data-aos-easing="ease-in-sine">Cyber</h1>
                                        <h1 className='leftsection-head leftsection-head2' data-aos="fade-right"
                                            data-aos-offset="200"
                                            data-aos-easing="ease-in-sine">Security</h1>
                                        <p className='leftsection-txt'>We offer cybersecurity solutions to protect businesses from threats, secure data, and ensure compliance. 🚀</p>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div
                                        className='homemain-rightsection'
                                        onMouseMove={handleMouseMove}
                                        onMouseLeave={resetTransform}
                                        style={{
                                            transform: `perspective(1000px) rotateX(${transform.rotateX}deg) rotateY(${transform.rotateY}deg)`,
                                            transition: 'transform 0.1s ease',
                                            transformStyle: 'preserve-3d'
                                        }}
                                    >
                                        <img className='home-rightsecim' src='../assets/images/slide/slideimage2.webp' alt='slider-image' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>


                    <SwiperSlide>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='homemain-leftsection'>
                                        <p className='leftsection-subtext' data-aos="fade-right"
                                            data-aos-offset="200"
                                            data-aos-easing="ease-in-sine">4Sight Tech INFORMATION TECHNOLOGY</p>
                                        <h1 className='leftsection-head' data-aos="fade-right"
                                            data-aos-offset="200"
                                            data-aos-easing="ease-in-sine">QA</h1>
                                        <h1 className='leftsection-head leftsection-head2' data-aos="fade-right"
                                            data-aos-offset="200"
                                            data-aos-easing="ease-in-sine">Services </h1>
                                        <p className='leftsection-txt'>We offer QA services to ensure software quality, enhance performance, and deliver bug-free applications. 🚀 </p>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div
                                        className='homemain-rightsection'
                                        onMouseMove={handleMouseMove}
                                        onMouseLeave={resetTransform}
                                        style={{
                                            transform: `perspective(1000px) rotateX(${transform.rotateX}deg) rotateY(${transform.rotateY}deg)`,
                                            transition: 'transform 0.1s ease',
                                            transformStyle: 'preserve-3d'
                                        }}
                                    >
                                        <img className='home-rightsecim' src='../assets/images/slide/QA.webp' alt='slider-image' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='homemain-leftsection'>
                                        <p className='leftsection-subtext' data-aos="fade-right"
                                            data-aos-offset="200"
                                            data-aos-easing="ease-in-sine">4Sight Tech INFORMATION TECHNOLOGY</p>
                                        <h1 className='leftsection-head' data-aos="fade-right"
                                            data-aos-offset="200"
                                            data-aos-easing="ease-in-sine">Artificial</h1>
                                        <h1 className='leftsection-head leftsection-head2' data-aos="fade-right"
                                            data-aos-offset="200"
                                            data-aos-easing="ease-in-sine">Intelligence</h1>
                                        <p className='leftsection-txt'>We offer AI services to automate processes, enhance decision-making, and drive business innovation. 🚀</p>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div
                                        className='homemain-rightsection'
                                        onMouseMove={handleMouseMove}
                                        onMouseLeave={resetTransform}
                                        style={{
                                            transform: `perspective(1000px) rotateX(${transform.rotateX}deg) rotateY(${transform.rotateY}deg)`,
                                            transition: 'transform 0.1s ease',
                                            transformStyle: 'preserve-3d'
                                        }}
                                    >
                                        <img className='home-rightsecim' src='../assets/images/slide/ai.webp' alt='slider-image' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>




                </Swiper>
            </div>
            <div className='section2-main'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='section2-leftsection'>
                                <img className='section2-leftsectionim' src='../assets/images/Image-text.webp' alt='INFORMATION TECHNOLOGY' />
                                <h2
                                    className='animated-text'
                                    data-aos={window.innerWidth > 768 ? 'fade-left' : null}
                                    data-aos-offset={window.innerWidth > 768 ? '200' : null}
                                >
                                    4SIGHT TECH
                                </h2>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='section2-rightsection'>
                                <p className='rightsection-subhead'>4Sight Tech INFORMATION TECHNOLOGY</p>
                                <h2 className='rightsection-head' data-aos="fade-right" data-aos-offset="20"
                                    data-aos-easing="ease-in-sine">We Execute Our Ideas From The Start to Finish</h2>
                                <p className='rightsection-txt'>
                                    4Sight Tech is a visionary IT solution and development services provider, committed to empowering businesses with innovative technology solutions. With expertise spanning cloud services, application development, web design, Big Data analytics, robotic process automation, and cybersecurity, we deliver tailored strategies to meet the unique needs of our clients. Our team excels in driving digital transformation by leveraging cutting-edge tools and methodologies, ensuring seamless integration and scalability. At 4Sight Tech, we prioritize building long-term partnerships by providing exceptional service and fostering growth across industries. Together, we shape the future of technology to help businesses thrive in an ever-evolving digital landscape.
                                </p>
                                <p className='rightsection-txt rightsection-txt2'>
                                    In the new Age of Information Technology, we intend to deliver proficiency in solutions and engaging our clients with enterprise resource planning for delivering and completing projects with unmatched quality, exploring the scope for product development in the areas of Business Analytics, DevOps and Cognitive Automation.
                                </p>
                                <div className='rightsection-btsec'>
                                    {/* <NavLink style={{ textDecoration: 'none' }}>
                                        <div className="rightsection-bt">
                                            <p className='rightsection-bttxt'>Learn More</p>
                                            <img className='rightsection-btim' src='../assets/images/icons/Vector.png' alt='right-arrow icon' />
                                        </div>
                                    </NavLink> */}
                                    <div className='rightsection-call'>
                                        <img className='rightsection-callim' src='../assets/images/CallIcon.png' alt='right-arrow icon' />
                                        <p className='rightsection-calltxt'>+1 945-419-8003</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='section3-main'>
                <img className='section3-mainbg' src='../assets/images/section3_bg.webp' alt='section3 pic' />
                <div className='container'>
                    <div className='section3-mainsubtextsec'>
                        <h3 className='section3-subhead'>EXPLORE OUR SERVICES</h3>
                    </div>
                    <h2 className='section3-mainhead' data-aos="fade-right" data-aos-offset="20"
                        data-aos-easing="ease-in-sine">COMMITTED TO PROVIDE BEST SERVICES</h2>
                    <div className='row'>
                        <div className='col-md-4'>
                            <div className='section3-leftsection'>
                                {/* <img className='section3-leftsectionim' src='../assets/images/icon.png' alt='sft' /> */}
                                <div className='section3-leftsectionim'>
                                    <img className='' src='../assets/images/icons-about/CloudComputing.png' alt='sft' />
                                </div>
                                <div className='section3-lefttxtsection'>
                                    <h3 className='section3-leftsubhead'>Cloud Services</h3>
                                    <p className='section3-leftsubtxt'>
                                        At 4Sight Tech, we provide cutting-edge cloud computing services built for the cybersecurity industry. Our mission is to help your company secure, store, and scale data in the cloud—without compromise. we bring clarity and expertise every step of the way.
                                    </p>
                                    <ul className='section3-leftul'>
                                        <li className='section3-lefttxt'> <img src='../assets/images/icons/Vectorarrow.png' alt='arrow icon' /> Cloud Database Management</li>
                                        <li className='section3-lefttxt'><img src='../assets/images/icons/Vectorarrow.png' alt='arrow icon' />Cloud-based Prototype Design</li>
                                        <li className='section3-lefttxt'><img src='../assets/images/icons/Vectorarrow.png' alt='arrow icon' />Cloud Project Deployment</li>
                                    </ul>

                                    <NavLink style={{ textDecoration: 'none' }} to={'/Cloud-Services'}>
                                        <div className='section3-leftbtsec'>
                                            <h3 className='section3-leftbtsectxt'>VIEW MORE</h3>
                                            <div className='section3-leftbtsecbt'>
                                                <img src='../assets/images/icons/Icon_arrow_right.png' alt='arrow icon' />
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='section3-leftsection'>
                                {/* <img className='section3-leftsectionim' src='../assets/images/icon.png' alt='sft' /> */}
                                <div className='section3-leftsectionim'>
                                    <img className='' src='../assets/images/icons-about/CustomFeaturing.png' alt='sft' />
                                </div>
                                <div className='section3-lefttxtsection'>
                                    <h3 className='section3-leftsubhead'>Software Development</h3>
                                    <p className='section3-leftsubtxt'>
                                        At 4Sight Tech, we build custom software solutions tailored to your business needs. From concept to deployment, our team delivers secure, scalable, and high-performance applications that drive innovation and efficiency.
                                    </p>
                                    <ul className='section3-leftul'>
                                        <li className='section3-lefttxt'> <img src='../assets/images/icons/Vectorarrow.png' alt='arrow icon' />Database Development</li>
                                        <li className='section3-lefttxt'><img src='../assets/images/icons/Vectorarrow.png' alt='arrow icon' />Prototype Designing</li>
                                        <li className='section3-lefttxt'><img src='../assets/images/icons/Vectorarrow.png' alt='arrow icon' />Project Implementation</li>
                                    </ul>

                                    <NavLink style={{ textDecoration: 'none' }} to={'/Software-Development'}>
                                        <div className='section3-leftbtsec'>
                                            <h3 className='section3-leftbtsectxt'>VIEW MORE</h3>
                                            <div className='section3-leftbtsecbt'>
                                                <img src='../assets/images/icons/Icon_arrow_right.png' alt='arrow icon' />
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='section3-leftsection'>
                                {/* <img className='section3-leftsectionim' src='../assets/images/icon.png' alt='sft' /> */}
                                <div className='section3-leftsectionim'>
                                    <img className='img2' src='../assets/images/icons-about/CyberSecurity.png' alt='sft' />
                                </div>
                                <div className='section3-lefttxtsection'>
                                    <h3 className='section3-leftsubhead'>Cyber Security</h3>
                                    <p className='section3-leftsubtxt'>
                                        At 4Sight Tech, we help businesses protect their digital assets with advanced cybersecurity solutions. From securing cloud infrastructure to protecting sensitive data, we deliver end-to-end security strategies tailored to your unique needs.
                                    </p>
                                    <ul className='section3-leftul'>
                                        <li className='section3-lefttxt'> <img src='../assets/images/icons/Vectorarrow.png' alt='arrow icon' />Database Security Management</li>
                                        <li className='section3-lefttxt'><img src='../assets/images/icons/Vectorarrow.png' alt='arrow icon' />Security Protocol Designing</li>
                                        <li className='section3-lefttxt'><img src='../assets/images/icons/Vectorarrow.png' alt='arrow icon' />Cyber Security Implementation</li>
                                    </ul>

                                    <NavLink style={{ textDecoration: 'none' }} to={'/Cyber-Security'}>
                                        <div className='section3-leftbtsec'>
                                            <h3 className='section3-leftbtsectxt'>VIEW MORE</h3>
                                            <div className='section3-leftbtsecbt'>
                                                <img src='../assets/images/icons/Icon_arrow_right.png' alt='arrow icon' />
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='section5-main'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-5'>
                            <div className='section5-leftsection'>
                                <p className='section5-leftsectionsubhead'>WHY CHOOSE 4SIGHT TECH</p>
                                <h3 className='section5-leftsectionhead' data-aos="fade-right" data-aos-offset="40"
                                    data-aos-easing="ease-in-sine">We CREATED LEGACY SINCE BEGINING</h3>
                                <div className='section5-leftsection-linesec'>
                                    <div className='section5-line'></div>
                                    <div className='section5-leftsection23' data-aos="fade-right" data-aos-offset="40"
                                        data-aos-easing="ease-in-sine">
                                        <div className='section5-leftsection23number'>
                                            <p className='section5-leftsection23numbertxt'>1</p>
                                        </div>
                                        <div className='section5-leftsection23Head-sec'>
                                            <h3 className='section5-leftsection23Head'>Expertise in technology</h3>
                                            <p className='section5-leftsection23subHead'>We combine deep technical knowledge with real-world experience to deliver innovative, secure, and scalable solutions.
                                                At 4 Sight Tech, technology isn't just our tool—it's our expertise.</p>
                                        </div>
                                    </div>
                                    <div className='section5-leftsection23' data-aos="fade-right" data-aos-offset="40"
                                        data-aos-easing="ease-in-sine">
                                        <div className='section5-leftsection23number'>
                                            <p className='section5-leftsection23numbertxt'>2</p>
                                        </div>
                                        <div className='section5-leftsection23Head-sec'>
                                            <h3 className='section5-leftsection23Head'>Amazing IT professionals</h3>
                                            <p className='section5-leftsection23subHead'>Our team is made up of passionate, skilled IT professionals dedicated to delivering excellence.
                                                At 4 Sight Tech, innovation starts with the people behind the tech.</p>
                                        </div>
                                    </div>
                                    <div className='section5-leftsection23' data-aos="fade-right" data-aos-offset="40"
                                        data-aos-easing="ease-in-sine">
                                        <div className='section5-leftsection23number'>
                                            <p className='section5-leftsection23numbertxt'>3</p>
                                        </div>
                                        <div className='section5-leftsection23Head-sec'>
                                            <h3 className='section5-leftsection23Head'>Perfect Execution System</h3>
                                            <p className='section5-leftsection23subHead'>We turn ideas into reality with a flawless execution process, from planning to deployment.
                                                At 4 Sight Tech, precision and performance define every step we take.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-7'>
                            <div className='section5-rightsection'>
                                <img className='section5-rightsectionim2' src='../assets/images/section5-im1.jpg' alt='laptop' />
                                <img className='section5-rightsectionim1' src='../assets/images/Laptop.webp' alt='laptop' />
                                <img className='section5-rightsectionim3' src='../assets/images/section5-im2.jpg' alt='laptop' />
                                <img className='section5-rightsectionim4' src='../assets/images/section5-im3.jpg' alt='laptop' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='section6-main'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='section6-leftsection'>
                                <p className='section6-leftsectionsub'>TECHNOLOGY WE SERVE</p>
                                <h3 className='section6-leftsectionhead' data-aos="fade-right" data-aos-offset="40"
                                    data-aos-easing="ease-in-sine">
                                    Modern Software
                                    TECH SOLUTIONs
                                </h3>
                                <p className='section6-leftsectiontxt'>
                                    Empowering businesses with cutting-edge software solutions built for today—and ready for tomorrow.
                                    At 4 Sight Tech, we blend innovation, agility, and smart tech to drive real results.
                                </p>
                                <div className='section6-leftsectionbtsec'>
                                    {/* <div className='section6-leftsectionbt1'>
                                        <p className='section6-leftsectionbt1txt'>Learn More</p>
                                        <img className='section6-leftsectionbt1im' src='../assets/images/icons/Vector.png' alt='arrow' />
                                    </div> */}
                                    <div className='section6-leftsectionbt2'>
                                        <img className='section6-leftsectionbt2im' src='../assets/images/CallIcon.png' alt='arrow' />
                                        <p className='section6-leftsectionbt2txt'>+1 945-419-8003</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='section6-rightsection'>
                                <div className='row'>
                                    <div className='col-4'>
                                        <div className='section6-rightsection-box'>
                                            <div className="flip-inner">
                                                <div className="flip-front">
                                                    <div className='flip-frontbox'>
                                                        <img className='flip-frontbox1' src='../assets/images/icons/icon.png' alt='IOS Platform' />
                                                    </div>
                                                    <h3 className='flip-frontbox-head'>IOS Platform</h3>
                                                </div>
                                                <div className="flip-back">
                                                    <div className='flip-backbox'>
                                                        <img className='flip-backbox1' src='../assets/images/icons/icon.png' alt='IOS Platform' />
                                                    </div>
                                                    <h3 className='flip-backbox-head'>IOS Platform</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-4'>
                                        <div className='section6-rightsection-box'>
                                            <div className="flip-inner">
                                                <div className="flip-front">
                                                    <div className='flip-frontbox'>
                                                        <img className='flip-frontbox1 flip-frontbox2' src='../assets/images/icons/icon2.png' alt='IOS Platform' />
                                                    </div>
                                                    <h3 className='flip-frontbox-head'>WordPress</h3>
                                                </div>
                                                <div className="flip-back">
                                                    <div className='flip-backbox'>
                                                        <img className='flip-backbox1 flip-backbox2' src='../assets/images/icons/icon2.png' alt='WordPress' />
                                                    </div>
                                                    <h3 className='flip-backbox-head'>WordPress</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-4'>
                                        <div className='section6-rightsection-box'>
                                            <div className="flip-inner">
                                                <div className="flip-front">
                                                    <div className='flip-frontbox'>
                                                        <img className='flip-frontbox1' src='../assets/images/icons/icon3.png' alt='IOS Platform' />
                                                    </div>
                                                    <h3 className='flip-frontbox-head'>Android Platform</h3>
                                                </div>
                                                <div className="flip-back">
                                                    <div className='flip-backbox'>
                                                        <img className='flip-backbox1' src='../assets/images/icons/icon3.png' alt='IOS Platform' />
                                                    </div>
                                                    <h3 className='flip-backbox-head'>Android Platform</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-4'>
                                        <div className='section6-rightsection-box'>
                                            <div className="flip-inner">
                                                <div className="flip-front">
                                                    <div className='flip-frontbox'>
                                                        <img className='flip-frontbox1' src='../assets/images/icons/icon4.png' alt='IOS Platform' />
                                                    </div>
                                                    <h3 className='flip-frontbox-head'>WEB</h3>
                                                </div>
                                                <div className="flip-back">
                                                    <div className='flip-backbox'>
                                                        <img className='flip-backbox1 flip-backbox4' src='../assets/images/icons/icon4.png' alt='IOS Platform' />
                                                    </div>
                                                    <h3 className='flip-backbox-head'>WEB</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-4'>
                                        <div className='section6-rightsection-box'>
                                            <div className="flip-inner">
                                                <div className="flip-front">
                                                    <div className='flip-frontbox'>
                                                        <img className='flip-frontbox1 flip-frontbox5' src='../assets/images/icons/icon5.png' alt='IOS Platform' />
                                                    </div>
                                                    <h3 className='flip-frontbox-head'>Wearables</h3>
                                                </div>
                                                <div className="flip-back">
                                                    <div className='flip-backbox'>
                                                        <img className='flip-backbox1 flip-backbox5' src='../assets/images/icons/icon5.png' alt='WordPress' />
                                                    </div>
                                                    <h3 className='flip-backbox-head'>Wearables</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-4'>
                                        <div className='section6-rightsection-box'>
                                            <div className="flip-inner">
                                                <div className="flip-front">
                                                    <div className='flip-frontbox'>
                                                        <img className='flip-frontbox1 flip-frontbox2' src='../assets/images/icons/icon6.png' alt='IOS Platform' />
                                                    </div>
                                                    <h3 className='flip-frontbox-head'>IOT</h3>
                                                </div>
                                                <div className="flip-back">
                                                    <div className='flip-backbox'>
                                                        <img className='flip-backbox1 flip-backbox2' src='../assets/images/icons/icon6.png' alt='IOS Platform' />
                                                    </div>
                                                    <h3 className='flip-backbox-head'>IOT</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-5'>
                            <div className='section6-section2'>
                                <img src='../assets/images/Image1.jpg' alt='pic' />
                            </div>
                        </div>
                        <div className='col-md-7'>
                            <img className='section6-section2' src='../assets/images/Image2.jpg' alt='pic' />
                        </div>
                    </div>
                    <div className='section6-section3'>
                        <div className='row'>
                            <div className='col-md-3'>
                                <div className='section6-section3-sub'>
                                    <h3 className='section6-section3-head'>{count1}K</h3>
                                    <p className='section6-section3-subtxt'>SESSION COMPLETED</p>
                                </div>
                            </div>
                            <div className='col-md-3'>
                                <div className='section6-section3-sub'>
                                    <h3 className='section6-section3-head'>{count2}+</h3>
                                    <p className='section6-section3-subtxt'>SESSION COMPLETED</p>
                                </div>
                            </div>
                            <div className='col-md-3'>
                                <div className='section6-section3-sub'>
                                    <h3 className='section6-section3-head'>{count3}</h3>
                                    <p className='section6-section3-subtxt'>SESSION COMPLETED</p>
                                </div>
                            </div>
                            <div className='col-md-3'>
                                <div className='section6-section3-sub'>
                                    <h3 className='section6-section3-head'>{count4}%</h3>
                                    <p className='section6-section3-subtxt'>SESSION COMPLETED</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='section7-main'>
                <div className='container'>
                    <div className='section7-mainsubtextsec'>
                        <h3 className='section7-subhead'>EXPLORE CASE STUDIES</h3>
                    </div>
                    <h2 className='section7-mainhead' data-aos="fade-right" data-aos-offset="40"
                        data-aos-easing="ease-in-sine">EXPLORE OUR AMAZING CASE STUDIES</h2>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='section7-section1'>
                                <img className='section7-section1im' src='../assets/images/section7-boxim.webp' alt='pic' />
                                <div className='section7-boxbg'>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div className='section7-subbox'>
                                                <p className='section7-subboxtxt'>Service Name:</p>
                                                <h3 className='section7-subboxhead'>Deploy scalable cloud infrastructure, migrate legacy systems</h3>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='section7-subbox'>
                                                <p className='section7-subboxtxt'>Client Name:</p>
                                                <h3 className='section7-subboxhead'>
                                                    NovaCore Technologies
                                                </h3>
                                                <p className='section7-subboxtxt section7-subboxtxt2'>Timeline: <span>2024-2025</span></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='section7-section1'>
                                <img className='section7-section1im' src='../assets/images/section7-im2.webp' alt='pic' />
                                <div className='section7-boxbg'>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div className='section7-subbox'>
                                                <p className='section7-subboxtxt'>Service Name:</p>
                                                <h3 className='section7-subboxhead'>Build custom web and enterprise applications, develop backend systems,</h3>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='section7-subbox'>
                                                <p className='section7-subboxtxt'>Client Name:</p>
                                                <h3 className='section7-subboxhead'> HexaByte Systems</h3>
                                                <p className='section7-subboxtxt section7-subboxtxt2'>Timeline: <span>2024-2025</span></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='section7-section1'>
                                <img className='section7-section1im' src='../assets/images/section7-im3.jpg' alt='pic' />
                                <div className='section7-boxbg'>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div className='section7-subbox'>
                                                <p className='section7-subboxtxt'>Service Name:</p>
                                                <h3 className='section7-subboxhead'>Implement threat detection systems, secure cloud environments.</h3>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='section7-subbox'>
                                                <p className='section7-subboxtxt'>Client Name:</p>
                                                <h3 className='section7-subboxhead'> Quantum Ridge Solutions</h3>
                                                <p className='section7-subboxtxt section7-subboxtxt2'>Timeline: <span>2024-2025</span></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='section7-section1'>
                                <img className='section7-section1im' src='../assets/images/section7-im4.webp' alt='pic' />
                                <div className='section7-boxbg'>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div className='section7-subbox'>
                                                <p className='section7-subboxtxt'>Service Name:</p>
                                                <h3 className='section7-subboxhead'>Perform automated and manual testing, ensure performance and security validation.</h3>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='section7-subbox'>
                                                <p className='section7-subboxtxt'>Client Name:</p>
                                                <h3 className='section7-subboxhead'> Vertexon Global Inc.</h3>
                                                <p className='section7-subboxtxt section7-subboxtxt2'>Timeline: <span>2024-2025</span></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='section8-main'>

                <div className='container' style={{ position: 'relative' }}>
                    <div className="nav-buttons">
                        <button ref={prevRef} className="nav-btn"><img src='../assets/images/icon-left.png' alt='' /></button>
                        <button ref={nextRef} className="nav-btn nav-btn2"><img src='../assets/images/icon-right.png' alt='' /></button>
                    </div>
                    <div className='row'>
                        <div className='col-md-5'>
                            <div className='section8-mainhead'>
                                <h2 className='section8-mainheadsub' data-aos="fade-right" data-aos-offset="40"
                                    data-aos-easing="ease-in-sine">Trusted by <span>25,000+ </span>
                                    happy customers</h2>
                            </div>
                        </div>
                        <div className='col-md-5'>
                            <div className='section8-mainhead'>
                                <p className='section8-maintxt'>We are 4Sight Tech, as a promising IT Company we are serving over a decade with our tremendous skill in the software development industry. </p>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <Swiper
                            modules={[Navigation]}
                            spaceBetween={30}
                            slidesPerView={3}
                            navigation={{
                                prevEl: prevRef.current,
                                nextEl: nextRef.current,
                            }}
                            autoplay={{
                                delay: 4500,
                                disableOnInteraction: false,
                            }}
                            loop={true}
                            onInit={(swiper) => {
                                swiper.params.navigation.prevEl = prevRef.current;
                                swiper.params.navigation.nextEl = nextRef.current;
                                swiper.navigation.init();
                                swiper.navigation.update();
                            }}
                            breakpoints={{
                                0: {
                                    slidesPerView: 1, // Mobile (default)
                                },
                                768: {
                                    slidesPerView: 2, // Tablets
                                },
                                1024: {
                                    slidesPerView: 3, // Desktop
                                },
                            }}
                        >
                            <SwiperSlide>
                                <div className="testimonial-card">
                                    <img className='stars' src='../assets/images/Rating.png' alt='rating' />
                                    <p className='review-text'>“4Sight Tech has been a game-changer for our cloud strategy. Their expertise in AWS and Azure helped us seamlessly migrate our applications, significantly improving performance and reducing costs.”</p>
                                    <img className='review-im' src='../assets/images/iconrev.png' alt='box' />
                                </div>
                                <div className="user-info">
                                    <img src="../assets/images/image1.png" alt="Ashley Jonathon" />
                                    <div>
                                        <h3>Rohan Mehta</h3>
                                        <small>Cloud Architect</small>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="testimonial-card">
                                    <img className='stars' src='../assets/images/Rating.png' alt='rating' />
                                    <p className='review-text'>“We struggled with manual deployments until 4Sight Tech stepped in. Their DevOps team automated our CI/CD pipeline, implemented containerization with Docker and Kubernetes, and optimized our cloud infrastructure.”</p>
                                    <img className='review-im' src='../assets/images/iconrev.png' alt='box' />
                                </div>
                                <div className="user-info">
                                    <img src="../assets/images/image1.png" alt="Ashley Jonathon" />
                                    <div>
                                        <h3>Neha Sharma</h3>
                                        <small>Head of Engineering</small>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="testimonial-card">
                                    <img className='stars' src='../assets/images/Rating.png' alt='rating' />
                                    <p className='review-text'>“Our AI-driven customer analytics project required advanced machine learning expertise. 4Sight Tech provided exceptional AI development services.”</p>
                                    <img className='review-im' src='../assets/images/iconrev.png' alt='box' />
                                </div>
                                <div className="user-info">
                                    <img src="../assets/images/image1.png" alt="Ashley Jonathon" />
                                    <div>
                                        <h3>Arjun Iyer</h3>
                                        <small>Data Science Lead</small>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="testimonial-card">
                                    <img className='stars' src='../assets/images/Rating.png' alt='rating' />
                                    <p className='review-text'>“4Sight Tech' software development team built a scalable web application tailored to our needs. Their agile approach and attention to detail ensured a smooth development cycle.”</p>
                                    <img className='review-im' src='../assets/images/iconrev.png' alt='box' />
                                </div>
                                <div className="user-info">
                                    <img src="../assets/images/image1.png" alt="Ashley Jonathon" />
                                    <div>
                                        <h3>Ananya Rao</h3>
                                        <small>Product Manager</small>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="testimonial-card">
                                    <img className='stars' src='../assets/images/Rating.png' alt='rating' />
                                    <p className='review-text'>“Migrating our IT infrastructure to the cloud was a daunting task, but 4Sight Tech made it effortless. They modernized our systems, improved security, and provided 24/7 support”</p>
                                    <img className='review-im' src='../assets/images/iconrev.png' alt='box' />
                                </div>
                                <div className="user-info">
                                    <img src="../assets/images/image1.png" alt="Ashley Jonathon" />
                                    <div>
                                        <h3>Vikram Patel</h3>
                                        <small>IT Director</small>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="testimonial-card">
                                    <img className='stars' src='../assets/images/Rating.png' alt='rating' />
                                    <p className='review-text'>“4Sight Tech has been a game-changer for our cloud strategy. Their expertise in AWS and Azure helped us seamlessly migrate our applications, significantly improving performance and reducing costs.”</p>
                                    <img className='review-im' src='../assets/images/iconrev.png' alt='box' />
                                </div>
                                <div className="user-info">
                                    <img src="../assets/images/image1.png" alt="Ashley Jonathon" />
                                    <div>
                                        <h3>Rohan Mehta</h3>
                                        <small>Cloud Architect</small>
                                    </div>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </div>

            <div className='section9-main'>
                <div className='container'>
                    <div className='section9-mainsubtextsec'>
                        <h3 className='section9-subhead'>LATEST NEWS</h3>
                    </div>
                    <h2 className='section9-mainhead' data-aos="fade-right" data-aos-offset="40"
                        data-aos-easing="ease-in-sine">READ THE LATEST NEWS</h2>

                    <div className='row'>
                        <div className='col-md-4'>
                            <div className='section9-subsection'>
                                <img className='section9-subsection-im' src='../assets/images/news/img1.webp' alt='news' />
                                <div className='section9-subsection2'>
                                    <h3 className='section9-subsection2-head'>Challenges of a new technology business in Year 2025</h3>
                                    <p className='section9-subsection2-txt'> We are committed to offering the best technology services to meet your unique needs. We 4Sight Tech understand that plumbing issues can be disruptive and stressful, which is why we go above and beyond to deliver exceptional service that surpasses your expectations.</p>
                                    <NavLink style={{ textDecoration: 'none' }} to={'/BlogPage'}>
                                        <div className='section9-subsection2-bt'>
                                            <p className='section9-subsection2-bttxt'>Read More</p>
                                        </div>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='section9-subsection'>
                                <img className='section9-subsection-im' src='../assets/images/news/img2.webp' alt='news' />
                                <div className='section9-subsection2'>
                                    <h3 className='section9-subsection2-head'>New plugins for creating new charts in dashboard</h3>
                                    <p className='section9-subsection2-txt'> For enterprise-level dashboards, FusionCharts has expanded its features with native support for responsive designs and the ability to incorporate drill-downs and data grouping. ApexCharts remains a top choice for its ease of integration with modern front-end frameworks like React and Vue, offering rich, interactive charts and seamless live data streaming.</p>
                                    <NavLink style={{ textDecoration: 'none' }}>
                                        <div className='section9-subsection2-bt'>
                                            <p className='section9-subsection2-bttxt'>Read More</p>
                                        </div>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='section9-subsection'>
                                <img className='section9-subsection-im' src='../assets/images/blog4.jpg' alt='news' />
                                <div className='section9-subsection2'>
                                    <h3 className='section9-subsection2-head'>The future of headset among Youngsters</h3>
                                    <p className='section9-subsection2-txt'> At 4 Sight Tech, we are closely monitoring the rapidly evolving landscape of technology, particularly the future of headsets among youngsters. The demand for advanced headsets is set to surge as immersive technologies like virtual reality (VR), augmented reality (AR), and high-quality audio experiences become increasingly integrated into everyday life. </p>
                                    <NavLink style={{ textDecoration: 'none' }}>
                                        <div className='section9-subsection2-bt'>
                                            <p className='section9-subsection2-bttxt'>Read More</p>
                                        </div>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='section10-main'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='section10-left'>
                                <h3 className='section10-leftHead'>Have a project in mind?</h3>
                                <p className='section10-leftsubHead'>Let’s talk to us</p>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='section10-right'>
                                <img className='section10-rightim' src='../assets/images/icons/icon_Phone.png' alt='' />
                                <div>
                                    <h3 className='section10-righthead'>Looking for collaboration?</h3>
                                    <p className='section10-righttxt'>Call Us +1 945-419-8003</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Home;